export default function TextContent() {
    return {
        restrict: "E",
        scope: {
            article: "="
        },
        template: require("./template.html")

        // link: function(scope, element, attrs){},

        // controller: function ($scope) { }
    };
}
